<template>
  <el-form>
    <el-form-item label="Name">
      <el-input v-model="info.title"></el-input>
    </el-form-item>
    <el-form-item label="Description">
      <el-input v-model="info.description" type="textarea" :rows="3" placeholder="what this atom do"></el-input>
    </el-form-item>

    <el-form-item label="Source code">
      <div class="black-editor-cont" style="min-height: 300px">
        <Editor lang="lua" editorId="code-editor" ref="codeEditor" :key="selectedAtomType"></Editor>
      </div>
    </el-form-item>


    <el-form-item label="Settings" v-if="info.settings.length">
      <div class="atom-tree">
        <ul>
          <li class="atom-tree-item" inline :key="idx" v-for="(item, idx) in info.settings" style="margin-bottom: 25px">
            <el-form :ref="`paramForm` + idx" :model="item">
              <div class="num">{{ idx + 1 }}.</div>
              <div class="atom-tree-item-cont">
                <el-form-item label="Title">
                  <el-input v-model="item.title" placeholder="For example: Choose keka"></el-input>
                </el-form-item>
                <el-form-item prop="name" label="Name" :rules="{
                  required: true,
                  message: 'Name can not be empty',
                  trigger: 'blur',
                }">
                  <el-input v-model="item.name" placeholder="For example: keka"></el-input>
                </el-form-item>
                <div class="item-cont-group">
                  <h4 class="tree-title-group">View</h4>

                  <div class="variables-group">
                    <el-form-item class="choose-var" prop="view">
                      <el-select v-model="item.view">
                        <el-option value="multiselect">Multiselect</el-option>
                        <el-option value="string">String</el-option>
                        <el-option value="checkbox">Checkbox</el-option>
                      </el-select>
                    </el-form-item>

                    <div class="control-var-item">
                      <el-form-item prop="value">
                        <el-checkbox v-if="item.view == 'checkbox'" v-model="item.modelBool">checked</el-checkbox>
                        <el-select v-if="item.view == 'multiselect'" v-model="item.modelMultiselect" allow-create
                          filterable multiple default-first-option>
                          <el-option v-for="val in item.value" :value="val" :key="val" :label="val">{{ val
                          }}</el-option>
                        </el-select>
                        <el-input v-if="item.view == 'string'" v-model="item.modelString"
                          placeholder="Default value"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                </div>
                <el-form-item>
                  <button type="button" @click="handleRemove(idx)" class="btn-sm btn-outline btn-outline-danger">
                    <i class="vik vik-delete"></i>Delete
                  </button>
                </el-form-item>
              </div>
            </el-form>
          </li>
        </ul>
      </div>
    </el-form-item>
    <div class="form-group">
      <div class="btn-line">
        <button @click="addSetting" type="button" class="btn btn-primary">
          <i class="vik vik-plus"></i>Add setting
        </button>

        <!-- <button type="button" @click="parseYAML" class="btn btn-success">
          <i class="vik vik-save"></i>Parse YAML
        </button> -->
        <button type="button" @click="save" class="btn btn-success">
          <i class="vik vik-save"></i>Save
        </button>
      </div>
    </div>
  </el-form>
</template>
<script>
import * as utils from "@/utils.js";
import { bus } from "@/bus.js";
import Editor from "@/components/internal/Editor.vue";
import { newScript } from "@/api.js";
import yaml from 'js-yaml';
// const yaml = require('js-yaml');

export default {
  data() {
    return {
      selectedAtomType: 'lua',
      info: {
        title: "",
        description: "",
        visibility: "private",
        settings: [],
        tags: [],

      },
    };
  },
  components: {
    Editor,
  },
  beforeDestroy() {
    window.onbeforeunload = null;
  },
  mounted() {
    // this.$refs.triggersEditor.setValue(`local db = require("db")\n\nfunction on_storage_put(task, data)\n--task: id \nend\n\nfunction on_task_finish(task)\nend`);
  },
  methods: {
    onCodeRecv(code) { },
    setActiveView(t) {
      this.selectedAtomType = t
    },
    processedSettings(settings) {
      for (var i in settings) {
        if (settings[i].view == "checkbox") {
          settings[i].value = settings[i].modelBool;
        }
        if (settings[i].view == "string") {
          settings[i].value = settings[i].modelString;
        }
        if (settings[i].view == "multiselect") {
          settings[i].value = settings[i].modelMultiselect;
        }
      }
      return settings;
    },
    parseYAML() {
      if (this.selectedAtomType == `lua`) {
      } else {
        let code = this.$refs.yamlEditor.getValue();
        try {
          const doc = yaml.load(code);
          console.log(doc);
        } catch (e) {
          console.log(e);
        }
      }

    },
    save() {
      console.log("call save")
      let that = this;
      let code = ``;

      code = this.$refs.codeEditor.getValue();


      newScript({
        title: this.info.title,
        description: this.info.description,
        code: code,
        settings: this.processedSettings(this.info.settings),
        revision: 1,
        type: this.selectedAtomType,
      }).then((res) => {
        if (res.status === "error") {
          that.$notify.error({
            title: "Error",
            message: res.error,
            duration: 10000,
          });
          return;
        }
        that.$router.push({
          name: "SingleAtom",
          params: {
            id: "" + res.id,
          },
        });
        bus.$emit("refresh-atoms");
      });
    },
    addSetting() {
      this.info.settings.push({
        name: "",
        title: "",
        modelBool: false,
        modelMultiselect: [],
        modelString: "",
        value: {},
        view: "checkbox",
        avaliableValues: [],
      });
    },
    handleRemove(index) {
      if (index > -1) {
        this.info.settings.splice(index, 1);
      }
    },
  },
};
</script>
<style>
.unit-group .nav-link.active,
.nav-pills .show>.nav-link {
  line-height: inherit !important;
}
</style>


// WEBPACK FOOTER //
// src/components/internal/NativeAtomBuilder.vue